<div>
  <h1>&nbsp;</h1>
  
  <button
    nxAction
    *ngFor="let action of actions"
    routerLinkActive="is-selected"
    type="button"
    (click)="sendMessage(action.label)"
  >
    <nx-icon nxActionIcon [name]="action.icon"></nx-icon>
  </button>

</div>
